import React from 'react';
import { useTranslation } from 'react-i18next';
import { MyCouponsCreate } from '@components/templates';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';

export function MyCouponsCreatePage() {
    const { t } = useTranslation();

    const translations = {
        title: t('my-coupons-create-component.metatags.title'),
        description: t('my-coupons-create-component.metatags.description'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.myCouponsCreate,
        index: false,
    });

    return <MyCouponsCreate />;
}
